module.exports = __webpack_public_path__ + "media/images/subsidy-bbb2ef698d945c2aabbcaf784858335e.svg";